// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".RateSection{display:flex;justify-content:space-around}.RateSection .rateBtn{margin:0 10px;cursor:pointer;font-family:Open Sans}@media screen and (max-width:576px){.RateSection .rateBtn{margin:0 0}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
